import { render } from "./DevelopmentProcess.vue?vue&type=template&id=24b5b5f5&scoped=true"
import script from "./DevelopmentProcess.vue?vue&type=script&lang=js"
export * from "./DevelopmentProcess.vue?vue&type=script&lang=js"

import "./DevelopmentProcess.vue?vue&type=style&index=0&id=24b5b5f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5b5f5"]])

export default __exports__